/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { BadRequestFragmentDoc } from '../../../../core/fragments/core.hook';
import { HcoSummaryFragmentDoc } from '../../../../core/fragments/Hco/HCOSummary.hook';
import { AddressFragmentDoc } from '../../../../core/fragments/Address/Address.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHcoAutocompleteQueryVariables = Types.Exact<{
	payload: Types.DcrhcoAutocompleteInput;
}>;

export type GetHcoAutocompleteQuery = {
	__typename?: 'Query';
	dcrHcoAutocomplete:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| { __typename?: 'Forbidden' }
		| {
				__typename?: 'HCOAutocompleteResults';
				results: Array<{
					__typename?: 'HCOAutocompleteResult';
					hco: {
						__typename?: 'HCO';
						vid_V: string;
						veevaid_V: string;
						statusCda_V?: string | null;
						statusCda_VId?: string | null;
						hcoNameCda_V?: string | null;
						hcoNameShort_V?: string | null;
						hcoNameEnglish_V?: string | null;
						hcoNameIntl_V?: string | null;
						hcoTypeCda_V?: string | null;
						addresses: Array<{
							__typename?: 'Address';
							streetAddress1Cda_V?: string | null;
							streetAddress1Intl_V?: string | null;
							streetAddress2Cda_V?: string | null;
							streetAddress2Intl_V?: string | null;
							postalCodeCda_V?: string | null;
							postalCodeIntl_V?: string | null;
							postalCodeFullUs_V?: string | null;
							cbsa_V?: string | null;
							latitudeCda_V?: number | null;
							longitudeCda_V?: number | null;
							statusCda_V?: string | null;
							statusCda_VId?: string | null;
							subStateAdminUnit_V?: string | null;
							businessCda_V?: boolean | null;
							dpvConfirmedIndicator_V?: string | null;
							buildingIdentifier_V?: string | null;
							phoneCda_V?: string | null;
							faxCda_V?: string | null;
							vid_V: string;
							primaryCda_V?: boolean | null;
							cityCda_V?: string | null;
							cityIntl_V?: string | null;
							stateCda_V?: string | null;
							countryCda_V?: string | null;
							hospitalCampus?:
								| {
										__typename?: 'HCO';
										vid_V: string;
										veevaid_V: string;
										statusCda_V?: string | null;
										statusCda_VId?: string | null;
										hcoNameCda_V?: string | null;
										hcoNameShort_V?: string | null;
										hcoNameEnglish_V?: string | null;
										hcoNameIntl_V?: string | null;
										hcoTypeCda_V?: string | null;
										addresses: Array<{
											__typename?: 'Address';
											vid_V: string;
											primaryCda_V?: boolean | null;
											cityCda_V?: string | null;
											cityIntl_V?: string | null;
											stateCda_V?: string | null;
											countryCda_V?: string | null;
											streetAddress1Cda_V?: string | null;
											streetAddress1Intl_V?: string | null;
											postalCodeCda_V?: string | null;
											postalCodeIntl_V?: string | null;
										}>;
										hcoType?: {
											__typename?: 'HCOType';
											id: string;
											name: string;
										} | null;
								  }
								| { __typename?: 'ResourceNotFound'; message: string }
								| null;
						}>;
						hcoType?: {
							__typename?: 'HCOType';
							id: string;
							name: string;
						} | null;
					};
				}>;
		  };
};

export const GetHcoAutocompleteDocument = gql`
	query GetHCOAutocomplete($payload: DCRHCOAutocompleteInput!) {
		dcrHcoAutocomplete(payload: $payload) {
			...BadRequest
			... on HCOAutocompleteResults {
				results {
					hco {
						...HCOSummary
						addresses(includeInactive: true) {
							...Address
						}
					}
				}
			}
		}
	}
	${BadRequestFragmentDoc}
	${HcoSummaryFragmentDoc}
	${AddressFragmentDoc}
`;

/**
 * __useGetHcoAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetHcoAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHcoAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHcoAutocompleteQuery({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useGetHcoAutocompleteQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetHcoAutocompleteQuery,
		GetHcoAutocompleteQueryVariables
	> &
		(
			| { variables: GetHcoAutocompleteQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<
		GetHcoAutocompleteQuery,
		GetHcoAutocompleteQueryVariables
	>(GetHcoAutocompleteDocument, options);
}
export function useGetHcoAutocompleteLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetHcoAutocompleteQuery,
		GetHcoAutocompleteQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetHcoAutocompleteQuery,
		GetHcoAutocompleteQueryVariables
	>(GetHcoAutocompleteDocument, options);
}
export function useGetHcoAutocompleteSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetHcoAutocompleteQuery,
				GetHcoAutocompleteQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetHcoAutocompleteQuery,
		GetHcoAutocompleteQueryVariables
	>(GetHcoAutocompleteDocument, options);
}
export type GetHcoAutocompleteQueryHookResult = ReturnType<
	typeof useGetHcoAutocompleteQuery
>;
export type GetHcoAutocompleteLazyQueryHookResult = ReturnType<
	typeof useGetHcoAutocompleteLazyQuery
>;
export type GetHcoAutocompleteSuspenseQueryHookResult = ReturnType<
	typeof useGetHcoAutocompleteSuspenseQuery
>;
export type GetHcoAutocompleteQueryResult = Apollo.QueryResult<
	GetHcoAutocompleteQuery,
	GetHcoAutocompleteQueryVariables
>;
